import { createApp } from 'vue'
import Menupral from '@/components/menu.vue'
import BusquedaComponent from '@/components/busqueda.vue'
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import { inicializarNavegacionPorDataLink } from '@/utils/navegacion'
import "@/lib/confirmar_delete.js"

import Rails from "@rails/ujs";
// evita el error si ya se ha cargado en modo HMR
if (!window.Rails) {
  Rails.start();
  window.Rails = Rails;
}

// Initialize Vue components
const initializeVueComponents = () => {
    // Initialize Menu component
    const menuElement = document.querySelector('[data-behavior="menuvue"]')
    if (menuElement) {
        try {
          const menuApp = createApp(Menupral, {
              activo: menuElement.dataset.activo || '',
              titulo: menuElement.dataset.titulo || 'Inicio',
              rol: menuElement.dataset.rol || 'user'
          })
          
          menuApp.mount(menuElement)
          // console.log('✅ Menu component mounted successfully')
        } catch (error) {
          console.error('❌ Error montando el componente menu:', error)
        }
    } else {
      console.warn('⚠️ No se encontró el elemento con data-behavior="menuvue"')
    }

    // Initialize Search component
    // console.log('🔍 Buscando elemento de búsqueda...')
    const searchElement = document.querySelector('[data-behavior="busqueda"]')
    // console.log('🔍 Elemento de búsqueda encontrado:', searchElement)
    
    if (searchElement) {
        const documento = searchElement.dataset.documento || 'facturas'
        // console.log('🔍 Documento detectado:', documento)
        
        // Validate if documento is searchable
        const searchableControllers = [
        'facturas', 'facturasm', 'albaranes', 'albaranesm', 
        'presupuestos', 'presupuestosm', 'entregasm', 
        'clientesm', 'articulosm'
        ]
        
        // console.log('🔍 Controllers válidos:', searchableControllers)
        // console.log('🔍 ¿Es válido?', searchableControllers.includes(documento))
        
        if (searchableControllers.includes(documento)) {
        try {
            // console.log('🔍 Intentando montar componente de búsqueda...')
            const searchApp = createApp(BusquedaComponent, {
            documento: documento
            })
            
            searchApp.mount(searchElement)
            // console.log('✅ Search component mounted successfully for:', documento)
        } catch (error) {
            console.error('❌ Error montando el componente de busqueda:', error)
        }
        } else {
        // console.log('⚠️ Controller no soporta búsqueda:', documento)
        // Mostrar mensaje de debug
        searchElement.innerHTML = '<div style="color: red;">Controller no válido: ' + documento + '</div>'
        }
    } else {
        // console.warn('⚠️ No se encontró el elemento con data-behavior="busqueda"')
        // console.log('🔍 Elementos disponibles con data-behavior:')
        // document.querySelectorAll('[data-behavior]').forEach(el => {
        //     console.log('  -', el.getAttribute('data-behavior'), el)
        // })
    }
    // Initialize Loading Spinner
    const loadingElement = document.querySelector('[data-behavior="loading"]')
    if (loadingElement) {
    try {
        const loadingApp = createApp(LoadingSpinner, {
        fullScreen: loadingElement.dataset.fullScreen === 'true'
        })
        
        loadingApp.mount(loadingElement);
        // console.log('✅ Loading spinner mounted successfully')
    } catch (error) {
        console.error('❌ Error montando el componente loading spinner:', error)
    }
    } else {
    console.warn('⚠️ No se encontró el elemento con data-behavior="loading"')
    }
}

// Initialize Semantic UI components
const initializeSemanticUI = () => {
  try {
    // Use main app container if Semantic's default context is missing
    const sidebarContext = $('.pushable')
    const contextTarget = sidebarContext.length ? sidebarContext : $('body')

    // Configure sidebar with better options
    $('.ui.labeled.icon.sidebar').sidebar({
      context: contextTarget,
      dimPage: false,
      transition: 'overlay',
      mobileTransition: 'overlay',
      closable: true,
      scrollLock: true,
      onShow: function() {
        // console.log('Sidebar opened')
      },
      onHide: function() {
        // console.log('Sidebar closed')
      }
    })

    // Initialize all dropdowns
    $('.ui.dropdown').dropdown({
      on: 'hover',
      duration: 150,
      transition: 'drop'
    })

    // console.log('✅ Semantic UI initialized successfully')
  } catch (error) {
    console.error('❌ Error inicializando Semantic UI:', error)
  }
}

// Set up event listeners
const setupEventListeners = () => {
  // Menu toggle functionality with better error handling
  document.querySelectorAll('.botonmenu').forEach(button => {
    button.addEventListener('click', (event) => {
      event.preventDefault()
      
      try {
        $('.ui.labeled.icon.sidebar').sidebar('toggle')
      } catch (error) {
        console.error('Error al hacer toogle del sidebar:', error)
      }
    })
  })

  // Close sidebar when clicking on main content (mobile UX improvement)
  document.addEventListener('click', (event) => {
    const sidebar = document.querySelector('.ui.sidebar')
    const isClickInsideSidebar = sidebar && sidebar.contains(event.target)
    const isMenuButton = event.target.closest('.botonmenu')
    
    if (!isClickInsideSidebar && !isMenuButton && window.innerWidth <= 768) {
      try {
        $('.ui.labeled.icon.sidebar').sidebar('hide')
      } catch (error) {
        console.error('Error al ocultar sidebar:', error)
      }
    }
  })

  // Handle escape key to close sidebar
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      try {
        $('.ui.labeled.icon.sidebar').sidebar('hide')
      } catch (error) {
        console.error('Error al ocultar sidebar pulsando esc:', error)
      }
    }
  })

  // console.log('✅ Event listeners setup completed')
}

// Initialize everything when DOM is ready
const initialize = () => {
  // console.log('🚀 Initializing application...')
  
  // Wait for jQuery and Semantic UI to be available
  const checkDependencies = () => {
    if (typeof window.jQuery === 'undefined') {
      // console.warn('⏳ Waiting for jQuery...')
      setTimeout(checkDependencies, 50)
      return
    }
    
    if (typeof window.jQuery.fn.sidebar === 'undefined') {
      // console.warn('⏳ Waiting for Semantic UI...')
      setTimeout(checkDependencies, 50)
      return
    }
    
    // All dependencies are ready, initialize everything
    try {
      initializeVueComponents()
      initializeSemanticUI()
      setupEventListeners()
      inicializarNavegacionPorDataLink()
      
      // console.log('✅ Application initialized successfully')
      
      // Dispatch custom event for other scripts that might need it
      document.dispatchEvent(new CustomEvent('app:initialized'))
    } catch (error) {
      console.error('❌ Error en la inicializacion:', error)
    }
  }
  
  checkDependencies()
}

// Start initialization when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize)
} else {
  // DOM is already ready
  initialize()
}

// Hot module replacement for development
if (import.meta.hot) {
  import.meta.hot.accept()
}
